// import './front-bootstrap'
import 'metro4'
import 'FrontComponents/js/metro-select/select'

import 'bootstrap-validator'
// import './vue-echo'
import '@fortawesome/fontawesome-free/js/all.min'

// import './serverDate'
// import './server-date'
import 'FrontComponents/js/countdown/countdown'
import 'FrontComponents/js/pnotify'

// Mobile Menu Script
require('./scripts/front/ma5-menu')

require('lightslider')
require('lightgallery')
require('lg-thumbnail')
require('lg-video')
require('lg-zoom')
// Plugins
import './plugins'

// Scripts
import './scripts/front/registration-wizard'
import './scripts/front/after-registration-wizard'
import './scripts/front/registration-wizard-fm'
import './scripts/front/address'
import './scripts/front/authentication'
import './scripts/front/sticky'
import './scripts/front/lot'
import './scripts/front/auction-trailer'
// import './scripts/front/preview'
import './scripts/front/button-wave-effect'
import './scripts/front/language-switcher'
import './scripts/front/scrollclick'
import './scripts/front/news'
import './scripts/front/alerts'
import './scripts/front/back-to-top'
import './scripts/front/videofullscreen'
// import './scripts/front/auction-view-types'
import './scripts/front/tooltip'
import './scripts/front/browser-tab-navigation'
// import './scripts/front/view-type'

// Image lazy loading
import './scripts/front/lazy-load'

// Vue.js Scripts
import './scripts/front/locale-settings'
import './scripts/front/bidbar'
import './scripts/front/pedigree'
import './scripts/front/back-to-top'
import './scripts/front/countdown'
import './scripts/front/add-to-wishlist'
import './scripts/front/foal-registration.js'
import './scripts/front/qualified-foals'
import './scripts/front/auctions-list'
import './scripts/front/auction-widgets'
import './scripts/front/user-requests'
import './scripts/front/owl.carousel'
import './scripts/front/own-owl-carousel'

import './scripts/front/modal'
import './scripts/front/some-scripts.js'

// Modify datepicker to select date on click
import './scripts/front/wheel-picker'
import './scripts/front/header'

import './scripts/front/check-browser.js'
import './scripts/front/date-format'
import './scripts/front/emergency-page-reload'
